import { useAuthStore } from '~/stores/auth';

export default defineNuxtPlugin((nuxtApp) => {
    const authStore = useAuthStore();

    // Initialize the token when the app starts
    authStore.initializeToken();

    console.log('---auth init---');
});